import { render, staticRenderFns } from "./origins-step.component.vue?vue&type=template&id=3e6c895a&scoped=true"
import script from "./origins-step.component.vue?vue&type=script&lang=ts"
export * from "./origins-step.component.vue?vue&type=script&lang=ts"
import style0 from "./origins-step.component.vue?vue&type=style&index=0&id=3e6c895a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6c895a",
  null
  
)

export default component.exports